import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import classNames from 'classnames';

export default function Divider(props) {
  return (
    <div className={classNames('divider pb-2', props.className)}>
      <Container>
        <Row>
          <Col>
            <svg viewBox="0 0 200 10" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
              <polyline points="1,1 100,9 199,1" fill="none" stroke="gray" strokeWidth="1px" strokeOpacity=".1" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
